export default __webpack_public_path__ + "static/media/site-logo.b5358572.svg";